import { Component } from 'react'

// Contains a Google Maps failure to the map box so the rest of the ARV screen keeps working.
// `failed` lets the caller switch to the fallback without unmounting this boundary, so errors
// thrown while the map subtree tears down are still caught here. React 19 logs caught errors itself.
export default class MapErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    return this.state.hasError || this.props.failed ? this.props.fallback : this.props.children
  }
}
